export default __webpack_public_path__ + "static/media/overview1.2e68bb71.jpg";